export default "__VITE_ASSET__CVKOrVLo__"